import React from 'lib/react';
import PropTypes from 'prop-types';
import {
  EVGrid,
} from 'lib/components';
import Typography from 'commonComponents/typography';
import { useSelector } from 'lib/redux';
import { CLAIM_INFO_FIELDS } from '../OrderHistory.constants';
import { getHighlightedText } from '../OrderHistory.utils';
import PropertyDataSection from './PropertyDataSection.component';

function CombinedExpandedSection({ expandedRowData, propertyDataMap, loadingPropertyData }) {
  const { searchText } = useSelector(({ orderHistory }) => ({ searchText: orderHistory.searchText }));

  // Extract reportId from expandedRowData to get property data from the map
  const {
    reportId,
    completeAddress,
    hasPropertyData,
    ...claimInfoData
  } = expandedRowData || {};
  const propertyData = reportId ? propertyDataMap[reportId] : null;
  return (
    <EVGrid container spacing={2}>
      {/* Existing Claim Info Section */}
      {claimInfoData && Object.keys(claimInfoData).length > 0 && (
        <EVGrid item xs={12}>
          <EVGrid
            container
            spacing={2}
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '16px',
              width: '100%',
            }}
          >
            {Object.keys(claimInfoData)
              .filter((key) => key !== 'completeAddress' && key !== 'reportId') // Don't show completeAddress or reportId in claim info
              .map((key) => (
                (claimInfoData[key]) && (
                  <EVGrid
                    key={key}
                    style={{
                      flex: '1 1 auto',
                      minWidth: '200px',
                      maxWidth: 'fit-content',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '4px',
                    }}
                  >
                    <Typography
                      variant="label-600"
                      style={{
                        textTransform: 'uppercase',
                        wordBreak: 'break-word',
                        whiteSpace: 'normal',
                      }}
                    >
                      {CLAIM_INFO_FIELDS[key]}
                    </Typography>
                    <Typography
                      variant="subtitle-400"
                      fontColor="charcoal-700"
                      style={{
                        wordBreak: 'break-word',
                        whiteSpace: 'normal',
                        overflowWrap: 'break-word',
                      }}
                    >
                      {getHighlightedText(claimInfoData[key], searchText)}
                    </Typography>
                  </EVGrid>
                )
              ))}
          </EVGrid>
        </EVGrid>
      )}

      {/* Property Data Section - Always expanded by default when available */}
      {hasPropertyData && (
        <EVGrid item xs={12}>
          {loadingPropertyData ? (
            <Typography variant="body-400" fontColor="charcoal-500">
              Loading property data...
            </Typography>
          ) : (
            propertyData && Object.keys(propertyData).length > 0 && (
              <PropertyDataSection propertyData={propertyData} />
            )
          )}
        </EVGrid>
      )}
    </EVGrid>
  );
}

CombinedExpandedSection.propTypes = {
  expandedRowData: PropTypes.shape({
    reportId: PropTypes.number,
    claimNumber: PropTypes.string,
    claimInfo: PropTypes.string,
    insuredName: PropTypes.string,
    catId: PropTypes.string,
    batchId: PropTypes.string,
    poNumber: PropTypes.string,
    dependentReportExternalReferenceId: PropTypes.string,
    policyNumber: PropTypes.string,
    dateOfLoss: PropTypes.string,
    completeAddress: PropTypes.string,
  }),
  propertyDataMap: PropTypes.objectOf(
    PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  ),
  loadingPropertyData: PropTypes.bool,
};

CombinedExpandedSection.defaultProps = {
  expandedRowData: null,
  propertyDataMap: {},
  loadingPropertyData: false,
};

export default CombinedExpandedSection;
